import React from "react";
import "./LoadingScreen.css";

const LoadingScreen = ({ message = "Preparing your learning journey..." }) => {
  return (
    <div className="loading-wrapper">
      <div className="logo-text">Stenope.AI Training</div>

      <div className="spinner-wrapper">
        <div className="spinner-ring"></div>
        <div className="spinner-ring inner"></div>
      </div>

      <p className="loading-text">{message}</p>
    </div>
  );
};

export default LoadingScreen;